import { LoginSuccessQueryParameters } from "~/components/article/article-comments-drawer/consts";

export const SanitizedUrlKeys = [LoginSuccessQueryParameters];
